<template>
  <div class="acseries-and-footer">
    <acseries></acseries>
    <scfooter></scfooter>
  </div>
</template>

<script>
 export default {
   name: 'accosmetics',
   components: {
     acseries: () => import('../components/ACseries.vue'),
     scfooter: () => import('../components/scFooter.vue')
   },
 }
</script>

<style lang="scss" scoped>
 $page-width: 960px;

 .acseries-and-footer {
   margin-top: 80px;
 }

 @media (max-width: 600px) {
   .acseries-and-footer {
     margin-top: 20px;
   }
 }
</style>
